export const CommonEnums = Object.freeze({
  DOCUMENT_MANDATORY: "Mandatory",
  DOCUMENT_OPTIONAL: "Optional",
  EXTENSION_PDF: "pdf",
  EXTENSION_DOC: "doc",
  EXTENSION_DOCX: "docx",
  EXTENSION_JPG: "jpg",
  EXTENSION_JPEG: "jpeg",
  EXTENSION_PNG: "png",
  LANGUAGE_EN: "en",
  LANGUAGE_AR: "ar",
  LANGUAGE_FR: "fr",
  LANGUAGE_HE: "he",
  LANGUAGE_UR: "ur",
  LANGUAGE_FA: "fa",
  LANGUAGE_ES: "es",
  MasterDocumentsAndTemplates: "masterDocuments",
  EventAtVendorOnboarding: "vendorOnboardingRequirements",
  EventAtStartOfJobApplication: "resourceRequirements",
  EventAtStartOfContractCreation: "contractRequirements",
  STATUS_APPROVED: "approved",
  STATUS_REJECTED: "rejected",
  MASTER_DOCUMENTS_TITLE: "Master Documents and Templates",
  VENDOR_ONBOARDING_TITLE: "Event – At Vendor Onboarding",
  RESOURCE_REQUIREMENTS_TITLE: "Event – At Start of Job Application",
  CONTRACT_REQUIREMENTS_TITLE: "Event – At Start of Contract Creation",
  BROWSER_FIREFOX: "Firefox",
  BROWSER_SAFARI: "Safari",
});
